var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import * as styles from './language-selector.styles';
import Dropdown from '../dropdown/dropdown';
import Typography from '../typography/typography';
export var LanguageSelector = function (_a) {
    var showOfflineAlert = _a.showOfflineAlert, currentLocale = _a.currentLocale, languages = _a.languages, selectLanguage = _a.selectLanguage;
    var _b = useState('en-za'), locale = _b[0], setLocale = _b[1];
    var _c = useState(false), isOfflineAlert = _c[0], setIsOfflineAlert = _c[1];
    var onChange = function (value) {
        if (navigator.onLine === false && showOfflineAlert) {
            return setIsOfflineAlert(true);
        }
        setLocale(value);
        selectLanguage(value);
    };
    var handleOfflineAlert = useCallback(function () {
        if (isOfflineAlert) {
            setTimeout(function () {
                setIsOfflineAlert(false);
            }, 5000);
        }
    }, [isOfflineAlert]);
    useEffect(function () {
        if (currentLocale) {
            setLocale(currentLocale);
        }
    }, [currentLocale]);
    useEffect(function () {
        handleOfflineAlert();
    }, [handleOfflineAlert]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: styles.localeDropDownWrapper }, { children: [_jsx("label", __assign({ className: styles.languageLabel }, { children: 'Change Language:' })), _jsx(Dropdown, { className: "w-32", fillColor: "quatenary", textColor: "white", fullWidth: true, fillType: "filled", labelColor: "white", selectedValue: locale, list: languages.map(function (language) { return ({
                            value: language.value,
                            label: language.label,
                        }); }) || [], onChange: onChange })] })), isOfflineAlert && (_jsx(Typography, { type: "help", color: "errorMain", text: 'You need to be online to change the language', className: "mt-2" }))] }));
};
export default LanguageSelector;
//# sourceMappingURL=language-selector.js.map